var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-icon-small-container"},[_c('div',{staticClass:"loading-icon",style:(_vm.overrideStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }